/* tslint:disable:no-shadowed-variable */
import camelcaseKeysDeep from 'camelcase-keys-deep'
import { ModuleNames } from '@/store/module-names'
import { SitesDetailedState } from './types'
import { ActionNames, MutationNames } from './keys'
import { getters } from './getters'
import { callApiWithoutDuplicate } from '@/store/utils/api'
import { getDetailedSiteById, GetSiteDetailedByIdDto } from '@/jsonapi/SiteDetailed'

const state: SitesDetailedState = {
  detailedSites: [],
}

const mutations = {
  [MutationNames.updateDetailedSites](state, payload): void {
    state.detailedSites = payload
  },
}

const actions = {
  async [ActionNames.getDetailedSiteById]({ commit, rootGetters }, payload: GetSiteDetailedByIdDto): Promise<void> {
    console.log('[ActionNames.getDetailedSiteById]', payload)
    await callApiWithoutDuplicate({
      commit,
      rootGetters,
      actionName: ActionNames.getDetailedSiteById,
      params: null,
      fn: async () => {
        const result = camelcaseKeysDeep(await getDetailedSiteById(payload))
        console.log('got result: ', result)
        debugger
        commit(MutationNames.updateDetailedSites, result)
      },
    })
  },
  // async [ActionNames.patchDetailedSite]({ commit }, payload) {
  //   if (payload.siteId) {
  //     await patchDetailedSiteQuery(payload)
  //   } else {
  //     await createDetailedSiteQuery(payload)
  //   }
  //   const results = camelcaseKeysDeep(await getDetailedSitesQuery(payload.id))
  //   commit(MutationNames.updateDetailedSites, results)
  // },
}

export default {
  name: ModuleNames.siteDetailed,
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
